import {useRef, useState} from "react";
import {useAltPosts} from '../../api/feed';
import {useBottomBar} from "../../app_context";
import {useFeedState, useStoreProfile} from '../../store';
import useFeedback from '../../utils/use_feedback';
import PostList from '../../components/post_list';
import Main from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import ErrorMessage from "../../components/error_message";

const AltPostsPage = ({title, type}) => {
    const {expand} = useStoreProfile();
    const {error, feedbackCh} = useFeedback();
    const signalRef = useRef(null);
    const key = `${type}/Win`;
    const feedState = useFeedState(key);
    const [restoredState, setRestoredState] = useState(feedState?.updatedTime > Date.now() - (15 * 60 * 1000) ? feedState : false);
    const {posts, more, loading, loadNextPage} = useAltPosts(feedbackCh, type, 'Win', signalRef, key, !restoredState);
    useBottomBar();
    return (
        <>
            <FixedTopBar back title={title} />
            <Main>
                <ErrorMessage error={error}/>
                <PostList
                    expand={expand} posts={posts} loading={loading} loadNextPage={more && loadNextPage}
                    signalRef={signalRef} feedKey={key} restoredState={restoredState}
                />
            </Main>
        </>
    );
};

export default AltPostsPage;
